import {
  getGetConversationUsageQueryKey,
  useGetConversationUsage,
} from 'api/generated/conversation-usage-controller/conversation-usage-controller';

export const TOKEN_USAGE_STALE_TIME_MS = 60_000;

export const conversationUsageQueryKey = (oktaUserId: string) =>
  getGetConversationUsageQueryKey(oktaUserId);

interface UseConversationUsageOptions {
  oktaUserId: string;
  enabled?: boolean;
}

export const useConversationUsage = ({
  oktaUserId,
  enabled = true,
}: UseConversationUsageOptions) =>
  useGetConversationUsage(oktaUserId, {
    query: {
      enabled: enabled && !!oktaUserId,
      staleTime: TOKEN_USAGE_STALE_TIME_MS,
      refetchOnWindowFocus: true,
      retry: false,
    },
  });
